import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportSalesLeadView,
    GetSalesLeadColumnChartValuesResultType,
    GetSalesLeadLineChartValuesResultType,
    GetSalesLeadMetricsValuesResultType,
    GetSalesLeadValuesParameters,
    GetSalesLeadValuesResultType,
    ReportResultColumnDto,
    SalesLeadClient,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class SalesLeadService extends CustomReportServiceBase<SalesLeadClient, CustomReportSalesLeadView> {
    constructor(protected override client: SalesLeadClient) {
        super(client);
    }

    async getSalesLeadValues(body: GetSalesLeadValuesParameters): Promise<GetSalesLeadValuesResultType[]> {
        return await lastValueFrom(this.client.salesLeadGetSalesLeadValues(body));
    }

    async getSalesLeadBoxesValues(parameters: GetSalesLeadValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.salesLeadGetSalesLeadBoxesValues(parameters));
    }

    async getSalesLeadColumnChartValues(
        body: GetSalesLeadValuesParameters
    ): Promise<GetSalesLeadColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.salesLeadGetSalesLeadColumnChartValues(body));
    }

    async getSalesLeadMetricsValues(body: GetSalesLeadValuesParameters): Promise<GetSalesLeadMetricsValuesResultType> {
        return await lastValueFrom(this.client.salesLeadGetSalesLeadMetricsValues(body));
    }

    async getSalesLeadLineChartValues(
        body: GetSalesLeadValuesParameters
    ): Promise<GetSalesLeadLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.salesLeadGetSalesLeadLineChartValues(body));
    }

    override async saveCustomReport(body: CustomReportSalesLeadView): Promise<CustomReportSalesLeadView> {
        if (body.isPublic) return await lastValueFrom(this.client.salesLeadSaveCatalogReport(body));
        else return await lastValueFrom(this.client.salesLeadSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportSalesLeadView> {
        return await lastValueFrom(this.client.salesLeadGetCustomReport(id));
    }

    override async shareReport(body: CustomReportSalesLeadView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.salesLeadCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportSalesLeadView> {
        return await lastValueFrom(this.client.salesLeadGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.salesLeadResultAvailableColumns(organizationIds));
    }
}
